// @flow
import { createTicketActions } from "./createTicketActionCreator";

const getFilteredClientList = (searchString, state) => {
  const searchStringLowerCase =
    searchString && searchString.toLowerCase().trim();
  const pageData = state.primeClientCodeOptions.data;
  let filteredArr;

  if (searchStringLowerCase && pageData) {
    filteredArr = pageData.filter(
      row =>
        (row.code &&
          row.code.toLowerCase().indexOf(searchStringLowerCase) >= 0) ||
        (row.clientName &&
          row.clientName.toLowerCase().indexOf(searchStringLowerCase) >= 0)
    );
  } else {
    filteredArr = pageData;
  }
  return filteredArr;
};

const initialState = {
  ticketTypes: {
    isLoading: false,
    isLoaded: false,
    data: null
  },
  ticketTypeDTO: {
    isLoading: false,
    isLoaded: false,
    data: null
  },
  ticket: {
    isLoading: false,
    isLoaded: false,
    data: null,
    allowAPIcall: true
  },
  orgClientInfoDetails: {
    isLoading: false,
    isLoaded: false,
    data: null
  },
  userInfo: {
    isLoading: false,
    isLoaded: false,
    data: null
  },
  assigneeOptions: {
    isLoading: false,
    isLoaded: false,
    data: null
  },
  clientCodeOptions: {
    isLoading: false,
    isLoaded: false,
    data: null
  },
  primeClientCodeOptions: {
    isLoading: false,
    isLoaded: false,
    data: [],
    filteredData: []
  },
  ccEmailDetails: {
    isLoaing: false,
    isLoaded: false,
    data: null
  },
  buTypes: {
    isLoaing: false,
    isLoaded: false,
    data: null
  },
  entityTypes: {
    isLoaing: false,
    isLoaded: false,
    data: null
  },
  locationData: {
    isLoading: false,
    isLoaded: false,
    data: null
  }
};

const createTicketReducer = (state: Object = initialState, action: Object) => {
  switch (action.type) {
    case createTicketActions.GET_ALL_TICKET_TYPES: {
      return Object.assign({}, state, { ticketTypes: action.payload });
    }
    case createTicketActions.GET_ALL_CATEGORIES: {
      return Object.assign({}, state, { categories: action.payload });
    }
    case createTicketActions.GET_ALL_LOCATIONS_DATA: {
      return Object.assign({}, state, { locationData: action.payload });
    }
    case createTicketActions.GET_TICKET_TYPE_DTO: {
      return Object.assign({}, state, { ticketTypeDTO: action.payload });
    }
    case createTicketActions.CREATE_TICKET_SUBMIT: {
      return Object.assign({}, state, { ticket: action.payload });
    }
    case createTicketActions.GET_ORG_CLIENT_DETAILS: {
      return Object.assign({}, state, { orgClientInfoDetails: action.payload });
    }
    case createTicketActions.GET_USER_INFO: {
      return Object.assign({}, state, { userInfo: action.payload });
    }
    case createTicketActions.GET_ASSIGNEE_OPTIONS: {
      return Object.assign({}, state, { assigneeOptions: action.payload });
    }
    case createTicketActions.GET_CLIENT_CODE_OPTIONS: {
      return Object.assign({}, state, { clientCodeOptions: action.payload });
    }
    case createTicketActions.GET_FILTERED_PRIME_CLIENT_CODE_OPTIONS: {
      const filteredClientList = getFilteredClientList(action.payload, state);
      return Object.assign({}, state, {
        primeClientCodeOptions: {
          isLoading: false,
          isLoaded: true,
          data: state.primeClientCodeOptions.data,
          filteredData: filteredClientList
        }
      });
    }
    case createTicketActions.GET_PRIME_CLIENT_CODE_OPTIONS: {
      return Object.assign({}, state, {
        primeClientCodeOptions: action.payload
      });
    }
    case createTicketActions.GET_CC_EMAIL_DETAILS: {
      return Object.assign({}, state, { ccEmailDetails: action.payload });
    }
    case createTicketActions.GET_ALL_BU_TYPES: {
      return Object.assign({}, state, { buTypes: action.payload });
    }
    case createTicketActions.GET_ENTITY_TYPES: {
      return Object.assign({}, state, { entityTypes: action.payload });
    }
    case createTicketActions.CLEAR_STATE: {
      return initialState;
    }
    default: {
      return state;
    }
  }
};

export default createTicketReducer;



// WEBPACK FOOTER //
// ./app/components/containers/ticketing/createTicket/createTicketRedux/createTicketReducer.js